// LICENSE_CODE ZON ISC
'use strict'; /*jslint node:true, browser:true*/
(function(){
var define;
var is_node = typeof module=='object' && module.exports && module.children;
if (is_node)
    define = require('./require_node.js').define(module, '../');
else
    define = self.define;
define(['/util/countries_locales.js'], function(countries_locales){
var E = {};
// based on:
// http://en.wikipedia.org/wiki/List_of_countries_by_spoken_languages
E.map_locale_to_country = {
    ach: ['ug'],
    af: ['za'],
    ak: ['gh'],
    am: ['et'],
    ar: ['eg', 'dz', 'sd', 'sa', 'ma', 'iq', 'sy', 'ye', 'tn', 'jo', 'ly',
        'lb', 'ae', 'mr', 'om', 'kw', 'qa', 'bh'],
    as: ['in'],
    ast: ['es'],
    az: ['az'],
    ban: ['id'],
    be: ['by'],
    bem: ['zm'],
    bg: ['bg'],
    bn: ['bd'],
    bo: ['ne'],
    br: ['fr'],
    bs: ['ba'],
    ca: ['ad'],
    ceb: ['ph'],
    chr: ['us'],
    cnr: ['me'],
    co: ['fr'],
    crs: ['sc'],
    cs: ['cz'],
    cy: ['gb'],
    da: ['dk'],
    de: ['de', 'at'],
    dv: ['mv'],
    dz: ['bt'],
    ee: ['tg', 'gh'],
    el: ['gr'],
    en: ['gb', 'us', 'au', 'hm', 'um', 'io', 'sg'],
    es: ['es'],
    et: ['ee'],
    eu: ['es'],
    fa: ['ir'],
    fi: ['fi'],
    fil: ['ph'],
    fo: ['fo'],
    fr: ['fr', 'pm', 'km', 'ht', 'mg', 'tn'],
    fy: ['nl'],
    ga: ['ie'],
    gaa: ['gh'],
    gd: ['gb', 'ca'],
    gl: ['es'],
    gn: ['py'],
    gu: ['in'],
    ha: ['ne', 'ng'],
    haw: ['us'],
    he: ['il'],
    hi: ['in'],
    hr: ['hr'],
    ht: ['ht'],
    hu: ['hu'],
    hy: ['am'],
    id: ['id'],
    ig: ['ng'],
    is: ['is'],
    it: ['it'],
    ja: ['jp'],
    jv: ['id'],
    ka: ['ge'],
    kab: ['dz'],
    kg: ['cd', 'cg'],
    kk: ['kz'],
    kl: ['gl'],
    km: ['kh'],
    kn: ['in'],
    ko: ['kr'],
    kok: ['in'],
    kri: ['sl'],
    ku: ['iq'],
    kw: ['gb'],
    ky: ['kg'],
    la: ['va'],
    lb: ['lu'],
    lg: ['ug'],
    ln: ['cd', 'cg'],
    lo: ['la'],
    loz: ['zm'],
    lt: ['lt'],
    lua: ['cd'],
    lv: ['lv'],
    mfe: ['mu'],
    mg: ['mg'],
    mi: ['nz'],
    mk: ['mk'],
    ml: ['in'],
    mn: ['mn'],
    mr: ['in'],
    ms: ['my', 'sg'],
    mt: ['mt'],
    my: ['mm'],
    nb: ['no'],
    ne: ['np'],
    nl: ['nl'],
    nn: ['no'],
    no: ['no', 'sj', 'bv'],
    nso: ['za'],
    ny: ['mw', 'zm'],
    nyn: ['ug'],
    oc: ['fr'],
    om: ['et'],
    or: ['in'],
    pa: ['pk'],
    pcm: ['ng'],
    pl: ['pl'],
    prs: ['af'],
    ps: ['af', 'pk'],
    pt: ['pt'],
    pt_br: ['br'],
    qu: ['ar'],
    quc: ['gt'],
    quz: ['pe'],
    rm: ['ch'],
    rn: ['bi'],
    ro: ['ro'],
    ru: ['ru'],
    rw: ['rw'],
    sc: ['it'],
    sd: ['pk', 'in'],
    si: ['lk'],
    sk: ['sk'],
    sl: ['si'],
    sn: ['zw'],
    so: ['so', 'dj'],
    sq: ['al'],
    sr: ['rs'],
    ss: ['sz'],
    st: ['ls'],
    su: ['id'],
    sv: ['se'],
    sw: ['ug', 'ke'],
    ta: ['lk', 'sg', 'in', 'my'],
    te: ['in'],
    tg: ['tj'],
    th: ['th'],
    ti: ['er'],
    tk: ['tm'],
    tl: ['ph'],
    tn: ['bw'],
    to: ['to'],
    tr: ['tr'],
    tt: ['ru'],
    tum: ['mw', 'tz', 'zm'],
    tw: ['gh'],
    ug: ['cn'],
    uk: ['ua'],
    ur: ['pk', 'in', 'fj'],
    uz: ['uz'],
    vi: ['vn'],
    wo: ['sn', 'gm', 'mr'],
    xh: ['za', 'zw'],
    yi: ['il'],
    yo: ['ng'],
    za: ['cn'],
    zh_cn: ['cn', 'sg'],
    zh_tw: ['tw', 'hk'],
    zu: ['za'],
};

// reverse of map_locale_to_country (langs sorted by popularity within country)
E.map_country_to_locale = {
    ad: ['ca'],
    ae: ['ar'],
    af: ['ps', 'prs'],
    ag: ['en'],
    ai: ['en'],
    al: ['sq'],
    am: ['hy'],
    an: ['nl'],
    ao: ['pt'],
    ar: ['es', 'qu'],
    as: ['en'],
    at: ['de'],
    au: ['en'],
    aw: ['nl'],
    ax: ['sv'],
    az: ['az'],
    ba: ['bs'],
    bb: ['en'],
    bd: ['bn'],
    be: ['nl', 'fr'],
    bf: ['fr'],
    bg: ['bg'],
    bh: ['ar'],
    bi: ['fr', 'rn'],
    bj: ['fr'],
    bl: ['fr'],
    bm: ['en'],
    bn: ['ms'],
    bo: ['es'],
    bq: ['nl'],
    br: ['pt_br'],
    bs: ['en'],
    bt: ['dz'],
    bw: ['tn'],
    by: ['be', 'ru'],
    bz: ['en'],
    ca: ['en', 'fr', 'gd'],
    cat: ['ca'],
    cc: ['en'],
    cd: ['fr', 'kg', 'lua', 'ln'],
    cf: ['en'],
    cg: ['fr', 'kg', 'ln'],
    ch: ['de', 'fr', 'it', 'rm'],
    ci: ['fr'],
    ck: ['en'],
    cl: ['es'],
    cm: ['fr'],
    cn: ['zh_cn', 'ug'],
    co: ['es'],
    cr: ['es'],
    cu: ['es'],
    cv: ['pt'],
    cw: ['nl'],
    cx: ['zh_cn'],
    cy: ['el'],
    cz: ['cs'],
    de: ['de'],
    dj: ['so'],
    dk: ['da'],
    dm: ['en'],
    do: ['es'],
    dz: ['ar', 'kab'],
    ec: ['es'],
    ee: ['et'],
    eg: ['ar'],
    eh: ['es'],
    er: ['ti'],
    es: ['es', 'ca', 'gl', 'eu', 'ast'],
    et: ['am', 'om'],
    fi: ['fi'],
    fj: ['ur'],
    fk: ['en'],
    fm: ['en'],
    fo: ['fo'],
    fr: ['fr', 'co', 'oc', 'br'],
    ga: ['fr'],
    gb: ['en', 'cy', 'gd', 'kw'],
    gd: ['en'],
    ge: ['ka'],
    gf: ['fr'],
    gg: ['en'],
    gh: ['en', 'ak', 'ee', 'gaa', 'tw'],
    gi: ['en'],
    gl: ['da', 'kl'],
    gm: ['en', 'wo'],
    gn: ['fr'],
    gp: ['fr'],
    gq: ['es', 'fr'],
    gr: ['el'],
    gs: ['en'],
    gt: ['es', 'quc'],
    gu: ['en'],
    gw: ['pt'],
    gy: ['en'],
    hk: ['zh_tw'],
    hm: ['en'],
    hn: ['es'],
    hr: ['hr'],
    ht: ['ht', 'fr'],
    hu: ['hu'],
    id: ['id', 'ban', 'su', 'jv'],
    ie: ['ga'],
    il: ['he', 'yi'],
    im: ['en'],
    in: ['hi', 'gu', 'kn', 'mr', 'ta', 'te', 'ur', 'as', 'kok', 'ml', 'or'],
    io: ['en'],
    iq: ['ar', 'ku'],
    ir: ['fa'],
    is: ['is'],
    it: ['it', 'sc'],
    je: ['en'],
    jm: ['en'],
    jo: ['ar'],
    jp: ['ja'],
    ke: ['sw'],
    kg: ['ky'],
    kh: ['km'],
    ki: ['en'],
    km: ['ar', 'fr'],
    kn: ['en'],
    kp: ['ko'],
    kr: ['ko'],
    kw: ['ar'],
    ky: ['en'],
    kz: ['kk'],
    la: ['lo'],
    lb: ['ar'],
    lc: ['en'],
    li: ['de'],
    lk: ['si', 'ta'],
    lr: ['en'],
    ls: ['st'],
    lt: ['lt'],
    lu: ['fr', 'de', 'lb'],
    lv: ['lv'],
    ly: ['ar'],
    ma: ['ar'],
    mc: ['fr'],
    md: ['ro'],
    me: ['sr', 'cnr'],
    mf: ['fr', 'en'],
    mg: ['mg', 'fr'],
    mh: ['en'],
    mk: ['mk'],
    ml: ['fr'],
    mm: ['my'],
    mn: ['mn'],
    mo: ['zh_cn'],
    mp: ['en'],
    mq: ['fr'],
    mr: ['ar', 'wo'],
    ms: ['en'],
    mt: ['mt'],
    mu: ['en', 'mfe'],
    mv: ['dv'],
    mw: ['en', 'ny', 'tum'],
    mx: ['es'],
    my: ['ms', 'ta'],
    mz: ['pt'],
    na: ['en'],
    nc: ['fr'],
    ne: ['fr', 'ha'],
    nf: ['en'],
    ng: ['en', 'ha', 'ig', 'yo', 'pcm'],
    ni: ['es'],
    nl: ['nl', 'fy'],
    no: ['no', 'nb', 'nn'],
    np: ['ne', 'bo'],
    nr: ['en'],
    nu: ['en'],
    nz: ['en', 'mi'],
    om: ['ar'],
    pa: ['es'],
    pe: ['es', 'quz'],
    pf: ['fr'],
    pg: ['en'],
    ph: ['tl', 'fil', 'ceb'],
    pk: ['pa', 'ps', 'ur'],
    pl: ['pl'],
    pm: ['fr'],
    pn: ['en'],
    pr: ['es'],
    ps: ['ar'],
    pt: ['pt'],
    pw: ['en'],
    py: ['gn', 'es'],
    qa: ['ar'],
    re: ['fr'],
    ro: ['ro'],
    rs: ['sr'],
    ru: ['ru', 'tt'],
    rw: ['rw'],
    sa: ['ar'],
    sb: ['en'],
    sc: ['en', 'crs'],
    sd: ['ar'],
    se: ['sv'],
    sg: ['en', 'zh_cn', 'ms', 'ta'],
    sh: ['en'],
    si: ['sl'],
    sj: ['no'],
    sk: ['sk'],
    sl: ['en', 'kri'],
    sm: ['it'],
    sn: ['fr', 'wo'],
    so: ['so'],
    sr: ['nl'],
    ss: ['en'],
    st: ['pt'],
    sv: ['es'],
    sx: ['nl', 'en'],
    sy: ['ar'],
    sz: ['ss'],
    tc: ['en'],
    td: ['ar'],
    tf: ['fr'],
    tg: ['fr', 'ee'],
    th: ['th'],
    tj: ['tg'],
    tk: ['en'],
    tl: ['pt'],
    tm: ['tk'],
    tn: ['ar', 'fr'],
    to: ['to'],
    tr: ['tr'],
    tt: ['en'],
    tv: ['en'],
    tw: ['zh_tw'],
    tz: ['sw', 'tum'],
    ye: ['ar'],
    ua: ['uk'],
    ug: ['sw', 'lg', 'nyn'],
    uk: ['en'],
    um: ['en'],
    us: ['en', 'chr', 'haw'],
    uy: ['es'],
    uz: ['uz'],
    va: ['it', 'la'],
    vc: ['en'],
    ve: ['es'],
    vg: ['en'],
    vi: ['en'],
    vn: ['vi'],
    vu: ['en', 'fr'],
    wf: ['fr'],
    ws: ['en'],
    xk: ['sq'],
    yt: ['fr'],
    za: ['af', 'nso', 'xh', 'zu'],
    zm: ['en', 'bem', 'loz', 'ny', 'tum'],
    zw: ['en', 'xh', 'sn'],
    bv: ['no'],
};

// based on:
// http://www.loc.gov/standards/iso639-2/php/code_list.php
// http://www.w3.org/WAI/ER/IG/ert/iso639.htm
// http://www.abbreviations.com/acronyms/LANGUAGES3L/99999
// http://www.abbreviations.com/acronyms/LANGUAGES2L/99999
E.map_locale_to_lang = {
    ach: ['acoli', 'lth'],
    af: ['afrikaans', 'afr'],
    ak: ['akan', 'aka'],
    am: ['amharic', 'amh'],
    ar: ['arabic', 'ara'],
    as: ['assamese', 'asamiya', 'asm'],
    ast: ['asturian'],
    az: ['azerbaijani', 'aze'],
    ban: ['balinese'],
    be: ['belarusian', 'bel'],
    bem: ['bemba', 'chibemba', 'ichibemba'],
    bg: ['bulgarian', 'bul'],
    bn: ['bengali', 'ben'],
    bo: ['tibetan', 'tib', 'bod'],
    br: ['breton', 'bre'],
    bs: ['bosnian', 'bos'],
    ca: ['catalan', 'valencian', 'cat'],
    ceb: ['cebuano', 'binisaya'],
    chr: ['cherokee', 'tsalagi'],
    cnr: ['montenegrin', 'crnogorski'],
    co: ['corsican', 'cos'],
    crs: ['seychellois creole', 'kreol'],
    cs: ['czech', 'cze', 'ces'],
    cy: ['welsh', 'cym', 'wel'],
    da: ['danish', 'dan'],
    de: ['german', 'ger', 'deu'],
    dv: ['dhivehi', 'maldivian', 'div'],
    dz: ['dzongkha', 'bhutanese', 'dzo'],
    ee: ['ewe'],
    el: ['greek', 'gre', 'ell'],
    en: ['english', 'eng'],
    eo: ['esperanto', 'epo'],
    es: ['spanish', 'spa'],
    et: ['estonian', 'est'],
    eu: ['basque', 'baq', 'eus'],
    fa: ['persian', 'farsi', 'farsi-persian', 'fsa', 'per'],
    fi: ['finnish', 'fin'],
    fil: ['filipino'],
    fo: ['faroese', 'fao'],
    fr: ['french', 'fre', 'fra'],
    fy: ['frisian', 'west frisian', 'western frisian', 'frysk', 'fry'],
    ga: ['irish', 'gle'],
    gaa: ['ga'],
    gd: ['scottish gaelic', 'scots gaelic', 'gaelic', 'gla'],
    gl: ['galician', 'glg'],
    gn: ['guarani', 'gug'],
    gu: ['gujarati', 'guj'],
    ha: ['hausa', 'hau'],
    haw: ['hawaiian'],
    he: ['hebrew', 'heb', 'iw'],
    hi: ['hindi', 'hin'],
    hr: ['croatian', 'hrv'],
    ht: ['haitian', 'hat'],
    hu: ['hungarian', 'hun'],
    hy: ['armenian', 'arm', 'hye'],
    ia: ['interlingua', 'ina'],
    id: ['indonesian', 'ind'],
    ig: ['igbo', 'ibo'],
    io: ['ido'],
    is: ['icelandic', 'ice', 'isl'],
    it: ['italian', 'ita'],
    ja: ['japanese', 'jpn'],
    jv: ['javanese', 'basa jawa', 'jawa', 'jw', 'jav'],
    ka: ['georgian', 'geo', 'kat'],
    kab: ['kabyle', 'kabylian', 'taqbaylit'],
    kg: ['kongo', 'kikongo', 'kon'],
    kk: ['kazakh', 'kaz'],
    kl: ['greenlandic', 'kal'],
    km: ['khmer', 'khm'],
    kn: ['kannada', 'kan'],
    ko: ['korean', 'kor'],
    kok: ['konkani'],
    kri: ['krio'],
    ku: ['kurdish', 'kurdi', 'kur', 'ckb'],
    kw: ['cornish', 'kernowek', 'kernewek', 'cor'],
    ky: ['kyrgyz', 'kir'],
    la: ['latin', 'lat'],
    lb: ['luxembourgish', 'ltz'],
    lg: ['ganda', 'luganda', 'oluganda', 'lug'],
    ln: ['lingala', 'ngala', 'lin'],
    lo: ['laotian', 'lao'],
    loz: ['lozi', 'silozi', 'rozi'],
    lt: ['lithuanian', 'lit'],
    lua: ['luba-kasai', 'western luba', 'bena-lulua', 'ciluba', 'tshiluba',
        'luba-lulua', 'luva'],
    lv: ['latvian', 'lav'],
    mfe: ['mauritian creole', 'morisien', 'morisyen', 'kreol morisien'],
    mg: ['malagasy', 'mlg'],
    mi: ['māori', 'te reo', 'mri', 'mao'],
    mk: ['macedonian', 'mac', 'mkd'],
    ml: ['malayalam', 'mal'],
    mn: ['mongolian', 'mon'],
    mr: ['marathi', 'mar'],
    ms: ['malay', 'msa', 'may'],
    mt: ['maltese', 'mlt'],
    my: ['burmese', 'bur', 'mya'],
    nb: ['norwegian bokmål', 'bokmål', 'nob'],
    ne: ['nepali', 'nep'],
    nl: ['dutch', 'flemish', 'nld', 'dut'],
    nn: ['nynorsk', 'nno'],
    no: ['norwegian', 'nor'],
    nso: ['northern sotho', 'sesotho sa leboa'],
    ny: ['chewa', 'nyanja', 'chichewa', 'chinyanja', 'nya'],
    nyn: ['nkore', 'nkole', 'nyankore', 'nyankole', 'runyankore', 'runyankole',
        'orunyankore', 'orunyankole'],
    oc: ['occitan', 'oci'],
    om: ['oromo', 'afaan oromoo', 'orm'],
    or: ['odia', 'oriya', 'ori'],
    pa: ['punjabi', 'pan'],
    pcm: ['nigerian pidgin', 'naija'],
    pl: ['polish', 'pol'],
    prs: ['dari'],
    ps: ['pashto', 'pus'],
    pt: ['portuguese', 'por'],
    pt_br: ['brazilian', 'brazilian-portuguese', 'pb', 'pob'],
    qu: ['quechua', 'quechuan', 'runasimi', 'runa simi', 'kechua', 'qwe'],
    quc: ['k\'iche\'', 'qatzijob\'al', 'quiché'],
    quz: ['cuzco quechua', 'qve'],
    rm: ['romansh', 'romansch', 'rumantsch', 'roh'],
    rn: ['rundi', 'kirundi', 'ikirundi', 'run'],
    ro: ['romanian', 'ron', 'moldovan', 'rum'],
    ru: ['russian', 'rus'],
    rw: ['kinyarwanda', 'kin'],
    sc: ['sardinian', 'sard', 'sardu', 'srd'],
    sd: ['sindhi', 'snd'],
    si: ['sinhala', 'sin'],
    sk: ['slovak', 'slo', 'slk'],
    sl: ['slovenian', 'slv'],
    sn: ['shona', 'chishona', 'sna'],
    so: ['somali', 'som'],
    sq: ['albanian', 'alb', 'sqi'],
    sr: ['serbian', 'srp'],
    ss: ['swazi', 'swati', 'siswati', 'ssw'],
    st: ['sotho', 'sot'],
    su: ['sundanese', 'basa sunda', 'sun'],
    sv: ['swedish', 'swe'],
    sw: ['swahili', 'swa'],
    ta: ['tamil', 'tam'],
    te: ['telugu', 'tel'],
    tg: ['tajik', 'tgk'],
    th: ['thai', 'tha'],
    ti: ['tigrinya', 'tir'],
    tk: ['turkmen', 'tuk'],
    tl: ['tagalog', 'tgl'],
    tn: ['tswana', 'tsn'],
    to: ['tongan', 'ton'],
    tok: ['toki pona', 'tokipona'],
    tr: ['turkish', 'tur'],
    tt: ['tatar', 'tat'],
    tum: ['tumbuka', 'chitumbuka', 'citumbuka'],
    tw: ['twi', 'akan kasa'],
    ug: ['uyghur', 'uighur', 'uig'],
    uk: ['ukrainian', 'ukr'],
    ur: ['urdu', 'urd'],
    uz: ['uzbek', 'uzb'],
    vi: ['vietnamese', 'vie'],
    wo: ['wolof', 'wol', 'wof'],
    xh: ['xhosa', 'isixhosa', 'xho'],
    yi: ['yiddish', 'yid'],
    yo: ['yoruba', 'yor'],
    za: ['zhuang', 'zha'],
    zh_cn: ['chinese', 'simplified chinese', 'chi', 'zho', 'zh', 'ze'],
    zh_tw: ['traditional chinese', 'zt'],
    zu: ['zulu', 'isizulu', 'zul'],
};

E.map_locale_to_short = {
    en: 'Eng',
    ru: 'Rus',
    es: 'Spa',
    pt_BR: 'Por',
    'pt-br': 'Por',
    fr: 'Fra',
    tr: 'Tur',
    zh_CN: '简体中文',
    'zh-hans': '简体中文',
    ja: '日本語',
    ko: '한국어'
};

E.map_locale_to_title = {
    en: 'EN',
    de: 'DE',
    ru: 'RU',
    es: 'ES',
    pt_BR: 'PT',
    'pt-br': 'PT',
    fr: 'FR',
    zh_CN: 'CN',
    'zh-hans': 'CN',
    ja: 'JA'
};

E.map_locale_to_long = {
    en: 'English',
    ru: 'Русский',
    es: 'Español',
    pt_BR: 'Português',
    'pt-br': 'Português',
    fr: 'French',
    tr: 'Turkish',
    zh_CN: '简体中文',
    'zh-hans': '简体中文',
    ja: '日本語',
    ko: 'Korean',
    de: 'Deutsch'
};

E.map_hostname_to_locale = {
    'brightdata.com': 'en',
    'luminati-china.biz': 'zh-hans',
    'bright.cn': 'zh-hans',
    'www.bright.cn': 'zh-hans',
    'ru-brightdata.com': 'ru',
    'brightdata.es': 'es',
    'brightdata.com.br': 'pt-br',
    'brightdata.jp': 'ja',
    'brightdata.fr': 'fr',
    'brightdata.de': 'de',
};

E.map_locale_to_hostname = Object.keys(E.map_hostname_to_locale).reduce(
    function(res, l){
        res[E.map_hostname_to_locale[l]] = l;
        return res;
        }, {}
);

// scraped from https://www.google.com/preferences#languages
E.google_list = {
    ach: 'Acoli',
    af: 'Afrikaans',
    ak: 'Akan',
    ig: 'Asụsụ Igbo',
    ban: 'Balinese',
    su: 'Basa Sunda',
    ceb: 'Binisaya',
    'xx-bork': 'Bork, bork, bork!',
    co: 'Corsican',
    cy: 'Cymraeg',
    de: 'Deutsch',
    'xx-elmer': 'Elmer Fudd',
    en: 'English',
    ee: 'Eʋegbe',
    fil: 'Filipino',
    tl: 'Filipino',
    fy: 'Frysk',
    gaa: 'Ga',
    ga: 'Gaeilge',
    gn: 'Guarani',
    gd: 'Gàidhlig',
    'xx-hacker': 'Hacker',
    ht: 'Haitian Creole',
    ha: 'Hausa',
    bem: 'Ichibemba',
    rn: 'Ikirundi',
    id: 'Indonesia',
    jw: 'Jawa',
    rw: 'Kinyarwanda',
    sw: 'Kiswahili',
    tlh: 'Klingon',
    kg: 'Kongo',
    kri: 'Krio (Sierra Leone)',
    la: 'Latin',
    loz: 'Lozi',
    lua: 'Luba-Lulua',
    lg: 'Luganda',
    mg: 'Malagasy',
    mt: 'Malti',
    ms: 'Melayu',
    mi: 'Māori',
    nl: 'Nederlands',
    pcm: 'Nigerian Pidgin',
    nso: 'Northern Sotho',
    ny: 'Nyanja',
    oc: 'Occitan',
    om: 'Oromoo',
    'xx-pirate': 'Pirate',
    qu: 'Runasimi',
    nyn: 'Runyankore',
    crs: 'Seychellois Creole',
    so: 'Soomaali',
    st: 'Southern Sotho',
    vi: 'Tiếng Việt',
    tn: 'Tswana',
    tum: 'Tumbuka',
    tw: 'Twi',
    tr: 'Türkçe',
    wo: 'Wolof',
    az: 'azərbaycan',
    bs: 'bosanski',
    br: 'brezhoneg',
    ca: 'català',
    sn: 'chiShona',
    da: 'dansk',
    et: 'eesti',
    es: 'español',
    'es-419': 'español (Latinoamérica)',
    eo: 'esperanto',
    eu: 'euskara',
    fr: 'français',
    fo: 'føroyskt',
    gl: 'galego',
    hr: 'hrvatski',
    ia: 'interlingua',
    xh: 'isiXhosa',
    zu: 'isiZulu',
    it: 'italiano',
    mfe: 'kreol morisien',
    lv: 'latviešu',
    to: 'lea fakatonga',
    lt: 'lietuvių',
    ln: 'lingála',
    hu: 'magyar',
    no: 'norsk',
    nn: 'nynorsk',
    uz: 'o‘zbek',
    pl: 'polski',
    'pt-BR': 'português (Brasil)',
    'pt-PT': 'português (Portugal)',
    ro: 'română',
    rm: 'rumantsch',
    sq: 'shqip',
    sk: 'slovenčina',
    sl: 'slovenščina',
    'sr-ME': 'srpski (Crna Gora)',
    'sr-Latn': 'srpski (latinica)',
    fi: 'suomi',
    sv: 'svenska',
    tk: 'türkmen dili',
    yo: 'Èdè Yorùbá',
    is: 'íslenska',
    cs: 'čeština',
    haw: 'ʻŌlelo Hawaiʻi',
    el: 'Ελληνικά',
    be: 'беларуская',
    bg: 'български',
    ky: 'кыргызча',
    mk: 'македонски',
    mn: 'монгол',
    ru: 'русский',
    sr: 'српски',
    tt: 'татар',
    tg: 'тоҷикӣ',
    uk: 'українська',
    kk: 'қазақ тілі',
    hy: 'հայերեն',
    yi: 'ייִדיש',
    iw: 'עברית',
    ug: 'ئۇيغۇرچە',
    ur: 'اردو',
    ar: 'العربية',
    sd: 'سنڌي',
    fa: 'فارسی',
    ps: 'پښتو',
    ckb: 'کوردیی ناوەندی',
    ne: 'नेपाली',
    mr: 'मराठी',
    hi: 'हिन्दी',
    bn: 'বাংলা',
    pa: 'ਪੰਜਾਬੀ',
    gu: 'ગુજરાતી',
    or: 'ଓଡ଼ିଆ',
    ta: 'தமிழ்',
    te: 'తెలుగు',
    kn: 'ಕನ್ನಡ',
    ml: 'മലയാളം',
    si: 'සිංහල',
    th: 'ไทย',
    lo: 'ລາວ',
    my: 'မြန်မာ',
    ka: 'ქართული',
    ti: 'ትግርኛ',
    am: 'አማርኛ',
    chr: 'ᏣᎳᎩ',
    km: 'ខ្មែរ',
    'zh-CN': '中文 (简体)',
    'zh-TW': '中文 (繁體)',
    ja: '日本語',
    ko: '한국어',
};

E.yandex_list = {
    ru: 'русский',
    en: 'English',
    fr: 'français',
    de: 'Deutsch',
    uk: 'українська',
    be: 'беларуская',
    tt: 'татар',
    kk: 'қазақ тілі',
    tr: 'Türkçe',
    id: 'Indonesia',
};

E.duckduckgo_list = {
    wt_WT: 'Browser preferred language',
    af_ZA: 'Afrikaans (South Africa)',
    ar_DZ: 'العربية (الجزائر)',
    ar_EG: 'العربية (مصر)',
    ar_SA: 'العربية (السعودية)',
    ast_ES: 'Asturianu',
    az_AZ: 'Azərbaycan dili',
    be_BY: 'Беларуская (Беларусь)',
    bg_BG: 'Български (България)',
    bn_BD: 'বাংলা(বাংলাদেশ)',
    bn_IN: 'বাংলা (ভারত)',
    br_FR: 'Brezhoneg',
    bs_BA: 'Bosanski',
    ca_ES: 'Català',
    cs_CZ: 'Čeština (Česká republika)',
    cy_GB: 'Cymraeg',
    da_DK: 'Dansk (Danmark)',
    de_CH: 'Deutsch (Schweiz)',
    de_DE: 'Deutsch (Deutschland)',
    el_GR: 'Ελληνικά (Ελλάδα)',
    en_AU: 'English (Australia)',
    en_CA: 'English (Canada)',
    en_GB: 'English (United Kingdom)',
    en_US: 'English (United States)',
    eo_XX: 'Esperanto',
    es_AR: 'Español (Argentina)',
    es_CL: 'Español (Chile)',
    es_CO: 'Español (Colombia)',
    es_CR: 'Español (Costa Rica)',
    es_EC: 'Español (Ecuador)',
    es_ES: 'Español (España)',
    es_MX: 'Español (México)',
    es_PE: 'Español (Perú)',
    es_UY: 'Español (Uruguay)',
    es_VE: 'Español (Venezuela)',
    et_EE: 'Eesti (Eesti)',
    eu_ES: 'Euskara',
    fa_IR: 'فارسی',
    fi_FI: 'Suomi (Suomi)',
    fr_BE: 'Français (Belgique)',
    fr_CA: 'Français (Canada)',
    fr_CH: 'Français (Suisse)',
    fr_FR: 'Français (France)',
    ga_IE: 'Gaeilge (Éire)',
    gd_GB: 'Gàidhlig',
    gl_ES: 'Galego',
    he_IL: 'עברית',
    hi_IN: 'हिंदी (भारत)',
    hr_HR: 'Hrvatski (Hrvatska)',
    hu_HU: 'Magyar (Magyarország)',
    hy_AM: 'Հայերեն',
    id_ID: 'Bahasa Indonesia',
    io_XX: 'Ido',
    is_IS: 'Íslenska (Ísland)',
    it_IT: 'Italiano (Italia)',
    ja_JP: '日本語 (日本)',
    kab_DZ: 'Taqbaylit',
    kn_IN: 'ಕನ್ನಡ (India)',
    ko_KR: '한국어 (대한민국)',
    ku: 'Kurdî',
    kw_GB: 'Kernowek',
    lt_LT: 'Lietuvių (Lietuva)',
    lv_LV: 'Latviešu (Latvija)',
    ml_IN: 'മലയാളം',
    mr_IN: 'मराठी',
    ms_MY: 'Bahasa Melayu (Malaysia)',
    nb_NO: 'Norsk (bokmål)',
    nl_BE: 'Nederlands (België)',
    nl_NL: 'Nederlands (Nederland)',
    nn_NO: 'Norsk (nynorsk)',
    od_IN: 'ଓଡ଼ିଆ (ଭାରତ)',
    pl_PL: 'Polski (Polska)',
    pt_BR: 'Português (Brasil)',
    pt_PT: 'Português (Portugal)',
    ro_RO: 'Română (România)',
    ru_RU: 'Русский (Россия)',
    sc_IT: 'Sardu (Sardigna)',
    si_LK: 'සිංහල',
    sk_SK: 'Slovenčina (Slovenská republika)',
    sl_SI: 'Slovenščina (Slovenija)',
    sq_AL: 'Shqip (Shqipëri)',
    sr_RS: 'Српски (Serbia)',
    sv_SE: 'Svenska (Sverige)',
    ta_IN: 'தமிழ்',
    te_IN: 'తెలుగు',
    th_TH: 'ไทย (ประเทศไทย)',
    tl_PH: 'Filipino',
    tokipona_XX: 'Toki Pona',
    tr_TR: 'Türkçe (Türkiye)',
    uk_UA: 'Українська (Україна)',
    ur_PK: 'اردو',
    vi_VN: 'Tiếng Việt (Việt Nam)',
    zh_CN: '中文 (中国)',
    zh_TW: '中文 (台灣)',
};

// scraped from https://www.bing.com/account/general#language-section
E.bing_list = {
    af: {english: 'Afrikaans', local: 'Afrikaans'},
    sq: {english: 'Albanian', local: 'Shqip'},
    am: {english: 'Amharic', local: 'አማርኛ'},
    ar: {english: 'Arabic', local: 'العربية'},
    hy: {english: 'Armenian', local: 'Հայերեն'},
    as: {english: 'Assamese', local: 'অসমীয়া'},
    'az-latn': {english: 'Azerbaijani (Latin)', local: 'azərbaycan'},
    bn: {english: 'Bangla', local: 'Bangla'},
    eu: {english: 'Basque', local: 'Euskara'},
    be: {english: 'Belarusian', local: 'Беларуская'},
    'bs-latn': {english: 'Bosnian (Latin)', local: 'bosanski'},
    bg: {english: 'Bulgarian', local: 'Български'},
    ca: {english: 'Catalan', local: 'català'},
    'ku-arab': {english: 'Central Kurdish', local: 'کوردیی ناوەڕاست'},
    'chr-cher': {english: 'Cherokee (Cherokee)', local: 'ᏣᎳᎩ'},
    'zh-Hans': {english: 'Chinese (Simplified)', local: '中文(简体)'},
    'zh-Hant': {english: 'Chinese (Traditional)', local: '中文(繁體)'},
    hr: {english: 'Croatian', local: 'hrvatski'},
    cs: {english: 'Czech', local: 'Čeština'},
    da: {english: 'Danish', local: 'dansk'},
    prs: {english: 'Dari', local: 'دری'},
    nl: {english: 'Dutch', local: 'Nederlands'},
    en: {english: 'English', local: 'English'},
    et: {english: 'Estonian', local: 'Eesti'},
    fil: {english: 'Filipino', local: 'Filipino'},
    fi: {english: 'Finnish', local: 'suomi'},
    fr: {english: 'French', local: 'Français'},
    gl: {english: 'Galician', local: 'Galego'},
    ka: {english: 'Georgian', local: 'ქართული'},
    de: {english: 'German', local: 'Deutsch'},
    el: {english: 'Greek', local: 'Ελληνικά'},
    gu: {english: 'Gujarati', local: 'ગુજરાતી'},
    'ha-latn': {english: 'Hausa (Latin)', local: 'Hausa'},
    he: {english: 'Hebrew', local: 'עברית'},
    hi: {english: 'Hindi', local: 'हिन्दी'},
    hu: {english: 'Hungarian', local: 'magyar'},
    is: {english: 'Icelandic', local: 'Íslenska'},
    ig: {english: 'Igbo', local: 'Igbo'},
    id: {english: 'Indonesian', local: 'Indonesia'},
    ga: {english: 'Irish', local: 'Gaeilge'},
    it: {english: 'Italian', local: 'Italiano'},
    ja: {english: 'Japanese', local: '日本語'},
    quc: {english: 'K\'iche\'', local: 'K\'iche\''},
    kn: {english: 'Kannada', local: 'ಕನ್ನಡ'},
    kk: {english: 'Kazakh', local: 'қазақ тілі'},
    km: {english: 'Khmer', local: 'ខ្មែរ'},
    rw: {english: 'Kinyarwanda', local: 'Kinyarwanda'},
    sw: {english: 'Kiswahili', local: 'Kiswahili'},
    kok: {english: 'Konkani', local: 'कोंकणी'},
    ko: {english: 'Korean', local: '한국어'},
    ky: {english: 'Kyrgyz', local: 'Кыргызча'},
    lo: {english: 'Lao', local: 'ລາວ'},
    lv: {english: 'Latvian', local: 'Latviešu'},
    lt: {english: 'Lithuanian', local: 'Lietuvių'},
    lb: {english: 'Luxembourgish', local: 'Lëtzebuergesch'},
    mk: {english: 'Macedonian', local: 'Македонски'},
    ms: {english: 'Malay (Latin)', local: 'Melayu'},
    ml: {english: 'Malayalam', local: 'മലയാളം'},
    mt: {english: 'Maltese', local: 'Malti'},
    mr: {english: 'Marathi', local: 'मराठी'},
    'mn-Cyrl-MN': {english: 'Mongolian (Cyrillic)',
        local: 'Mongolian (Cyrillic)'},
    mi: {english: 'Māori', local: 'Māori'},
    ne: {english: 'Nepali', local: 'नेपाली'},
    nb: {english: 'Norwegian Bokmål', local: 'Norwegian Bokmål'},
    nn: {english: 'Norwegian Nynorsk', local: 'Norwegian Nynorsk'},
    or: {english: 'Odia', local: 'ଓଡ଼ିଆ'},
    fa: {english: 'Persian', local: 'فارسی'},
    pl: {english: 'Polish', local: 'polski'},
    'pt-BR': {english: 'Portuguese (Brazil)', local: 'Português (Brasil)'},
    'pt-PT': {english: 'Portuguese (Portugal)', local: 'Português (Portugal)'},
    'pa-arab': {english: 'Punjabi (Arabic)', local: 'پنجابی'},
    'pa-guru': {english: 'Punjabi (Gurmukhi)', local: 'ਪੰਜਾਬੀ'},
    quz: {english: 'Quechua', local: 'Runasimi'},
    ro: {english: 'Romanian', local: 'Română'},
    ru: {english: 'Russian', local: 'русский'},
    gd: {english: 'Scottish Gaelic', local: 'Gàidhlig'},
    'sr-cyrl': {english: 'Serbian (Cyrillic)', local: 'српски'},
    'sr-latn': {english: 'Serbian (Latin)', local: 'српски (латиница)'},
    nso: {english: 'Sesotho sa Leboa', local: 'Sesotho sa Leboa'},
    tn: {english: 'Setswana', local: 'Setswana'},
    'sd-arab': {english: 'Sindhi (Arabic)', local: 'سنڌي'},
    si: {english: 'Sinhala', local: 'සිංහල'},
    sk: {english: 'Slovak', local: 'slovenčina'},
    sl: {english: 'Slovenian', local: 'slovenščina'},
    es: {english: 'Spanish', local: 'Español'},
    sv: {english: 'Swedish', local: 'Svenska'},
    'tg-cyrl': {english: 'Tajik (Cyrillic)', local: 'Тоҷикӣ'},
    ta: {english: 'Tamil', local: 'தமிழ்'},
    tt: {english: 'Tatar (Cyrillic)', local: 'татар'},
    te: {english: 'Telugu', local: 'తెలుగు'},
    th: {english: 'Thai', local: 'ไทย'},
    ti: {english: 'Tigrinya', local: 'ትግርኛ'},
    tr: {english: 'Turkish', local: 'Türkçe'},
    tk: {english: 'Turkmen (Latin)', local: 'türkmen dili'},
    uk: {english: 'Ukrainian', local: 'українська'},
    ur: {english: 'Urdu', local: 'اردو'},
    ug: {english: 'Uyghur (Arabic)', local: 'ئۇيغۇرچە'},
    'uz-latn': {english: 'Uzbek (Latin)', local: 'oʻzbekcha'},
    'ca-es-valencia': {english: 'Valencian', local: 'Valencià'},
    vi: {english: 'Vietnamese', local: 'Tiếng Việt'},
    cy: {english: 'Welsh', local: 'Cymraeg'},
    wo: {english: 'Wolof', local: 'Wolof'},
    yo: {english: 'Yoruba', local: 'Èdè Yorùbá'},
    xh: {english: 'isiXhosa', local: 'IsiXhosa'},
    zu: {english: 'isiZulu', local: 'isiZulu'},
};

// XXX arik: based on bext/pub/locale.js; improve with a language family
// table for language fallback
// chrome locales: https://developer.chrome.com/webstore/i18n?csw=1#localeTable
E.browser_locale = function(lang){
    var navlang = (lang||navigator.language||'').replace('-', '_')
        .toLowerCase();
    var choices = [navlang, navlang.substr(0, navlang.indexOf('_'))];
    for (var i=0; i<choices.length; i++)
    {
        if (E.map_locale_to_lang[choices[i]])
            return choices[i];
    }
    return 'en';
};

var to_locale_map;
E.to_locale = function(l){ return to_locale_map[(l||'').toLowerCase()]; };

E.locale_to_country = function(l){
    return E.map_locale_to_country[l] ? E.map_locale_to_country[l][0] : null;
};

E.country_to_locale = function(c){
    c = (c||'').toLowerCase();
    return E.map_country_to_locale[c] ? E.map_country_to_locale[c][0] : null;
};

var bing_locales;
E.country_to_bing_locale = function(c){
    c = (c||'').toLowerCase();
    var locales = E.map_country_to_locale[c]||[];
    var start = c=='km' ? 1 : 0;
    for (var i = start; i<locales.length; i++)
    {
        var locale = locales[i];
        if (bing_locales[locale])
            return bing_locales[locale];
    }
    return null;
};

E.local_from_file_name = function(file_name){
    var a = file_name.split(/[ .,\-_]/), l = a.length;
    for (var i=0; i<l; i++)
    {
        if (E.to_locale(a[l-i-1]))
            return E.to_locale(a[l-i-1]);
    }
};

E.accept_lang_for_country = function(locale){
    var idx = locale.indexOf('-');
    var country = (idx<0 ? locale : locale.substr(idx+1)).toUpperCase();
    var loc = countries_locales.json[country];
    if (!loc)
        return 'en';
    var language = idx<0 ? loc.lang : locale.substr(0, idx).toLowerCase();
    locale = idx<0 ? loc.locale : language+'-'+country;
    var r = [];
    if (locale!=language)
        r.push(locale);
    r.push(language);
    if (loc.fallback)
        r = r.concat(loc.fallback.split(','));
    if (r.length>10)
        r = r.slice(0, 10);
    return E.format_accept_lang(r);
};

E.format_accept_lang = function(set){
    set = set.slice();
    for (var i = 1; i<set.length; i++)
        set[i] += ';q=0.'+(10-i);
    return set.join(',');
};

E.locale_to_hostname = function(lang){
    return E.map_locale_to_hostname[lang] || E.map_locale_to_hostname.en;
};

E.hostname_to_locale = function(host, supported_languages){
    supported_languages = Array.isArray(supported_languages)
        ? supported_languages
        : [];
    var locale = E.map_hostname_to_locale[host] || 'en';
    if (supported_languages.length==0||supported_languages.includes(locale))
        return locale;
    return 'en';
};

E.fix_accept_lang_for_user_agent = function(value, user_agent){
    if (!value || !user_agent || !user_agent.includes('Firefox/'))
        return value;
    var q = value.match(/q=0\.(\d+)/gi);
    if (!q)
        return value;
    if (q.length==1)
        return value.replace(q[0], 'q=0.5');
    if (q.length==2)
        return value.replace(q[1], 'q=0.3').replace(q[0], 'q=0.7');
    if (q.length==3)
    {
        return value.replace(q[2], 'q=0.3').replace(q[1], 'q=0.5')
            .replace(q[0], 'q=0.8');
    }
    if (q.length==4)
    {
        return value.replace(q[3], 'q=0.2').replace(q[2], 'q=0.4')
            .replace(q[1], 'q=0.6').replace(q[0], 'q=0.8');
    }
    return value;
};

function init_to_locale_map(){
    to_locale_map = {};
    for (var locale in E.map_locale_to_lang)
    {
        var a = E.map_locale_to_lang[locale];
        to_locale_map[locale] = locale;
        for (var i = 0; i<a.length; i++)
            to_locale_map[a[i]] = locale;
    }
}

function init_bing_locales(){
    bing_locales = {zh_tw: 'zh-Hant', zh_cn: 'zh-Hans'};
    var locale, key;
    for (locale in E.bing_list)
    {
        key = locale.split('-')[0];
        bing_locales[key] = locale;
    }
    for (locale in E.bing_list)
    {
        key = locale.toLowerCase().replace(/-/g, '_');
        bing_locales[key] = locale;
    }
}

function init(){
    init_to_locale_map();
    init_bing_locales();
}

init();
return E; }); }());
